import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { bem } from 'helpers/class-name';

import { ControlsContext } from './Contexts';
import './Controls.scss';

const { block, element } = bem('controls');

const Controls = props => {
  const { children, inline, isDesktop, className } = props;

  if (!children) return null;

  const {
    filter: filters = [],
    button: buttons = [],
    trough: troughs = [],
  } = React.Children.toArray(children).reduce((acc, child) => {
    let type = child.props.type || 'other';

    if (child.props.venueSelector || child.props.rightButton) {
      type = 'filter';
    }

    return {
      ...acc,
      [type]: [...(acc[type] || []), child],
    };
  }, {});

  const content = (
    <div className={classNames(block(), className)}>
      <div className={element('container', { filter: true, inline })}>
        {filters.map(filter => React.cloneElement(filter, { className: element('filter', filter.props.className) }))}
      </div>
      <div className={element('container', { button: true })}>
        {buttons.map(button => React.cloneElement(button, { className: element('button', button.props.className) }))}
      </div>
      <div className={element('container', { trough: true })}>
        {troughs.map(trough => React.cloneElement(trough, { className: element('trough', trough.props.className) }))}
      </div>
    </div>
  );

  if (isDesktop && !inline) {
    return (
      <ControlsContext.Consumer>
        {ref => ref && ref.current && ReactDOM.createPortal(content, ref.current)}
      </ControlsContext.Consumer>
    );
  }

  return content;
};

Controls.propTypes = {
  children: PropTypes.node,
  inline: PropTypes.bool,
  isDesktop: PropTypes.bool,
  className: PropTypes.string,
};

export default Controls;
